import React from 'react';
import PropTypes from 'prop-types';

const DoctorChamberSchedules = ({ doctor, chamber }) => {
  const chamberSchedules = React.useMemo(
    () => doctor?.doctor_schedules?.filter(
      (schedule) => Number(schedule.chamber_id) === Number(chamber.id),
    ),
    [doctor?.doctor_schedules, chamber.id],
  );

  return (
    <ul>
      {chamberSchedules.map((schedule) => (
        <li key={schedule.id}>
          <p className="day">
            {schedule.available_day}
            ,
          </p>
          <p className="time">{schedule.available_time}</p>
          <p>
            সিরিয়ালের জন্য যোগাযোগ করুনঃ
            <br />
            {/* Phone call action button */}
            📞
            <a href={`tel:+88${schedule.contact}`}>{schedule.contact}</a>
          </p>
        </li>
      ))}
    </ul>
  );
};
DoctorChamberSchedules.propTypes = {
  doctor: PropTypes.shape({
    doctor_schedules: PropTypes.arrayOf(
      PropTypes.shape({
        chamber_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        available_day: PropTypes.string,
        available_time: PropTypes.string,
        contact: PropTypes.string,
      }),
    ),
  }),
  chamber: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

DoctorChamberSchedules.defaultProps = {
  doctor: null,
};

export default DoctorChamberSchedules;
